import PageHeader from './PageHeader';
import './PageHeader.scss';

export default PageHeader;
